import { render, staticRenderFns } from "./FixedBearingsDimension.vue?vue&type=template&id=3d979b9a&scoped=true"
import script from "./FixedBearingsDimension.vue?vue&type=script&lang=js"
export * from "./FixedBearingsDimension.vue?vue&type=script&lang=js"
import style0 from "./FixedBearingsDimension.vue?vue&type=style&index=0&id=3d979b9a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d979b9a",
  null
  
)

export default component.exports